import { render, staticRenderFns } from "./newVolDetail.vue?vue&type=template&id=2465f8fc&scoped=true&"
import script from "./newVolDetail.vue?vue&type=script&lang=js&"
export * from "./newVolDetail.vue?vue&type=script&lang=js&"
import style0 from "./newVolDetail.vue?vue&type=style&index=0&id=2465f8fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2465f8fc",
  null
  
)

export default component.exports